import * as React from "react";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { CookieConsentToggleProps } from "./typings";
import { useLocalization, ILocalization } from "@shared-ui/localization-context";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkSpacing } from "uitk-react-spacing";

export interface OsanoBannerClient {
  initialize: () => Promise<null>;
  cm: any;
}

export interface OnetrustClient {
  ToggleInfoDisplay: () => void;
}

declare const window: Window & {
  Osano: OsanoBannerClient;
  OneTrust: OnetrustClient;
};

export const CookieConsentToggle = withStores("context")(
  observer((props: CookieConsentToggleProps) => {
    const { templateComponent } = props;
    const { id } = templateComponent.metadata;

    const { formatText }: ILocalization = useLocalization();
    const showCookieDrawer = (): void => {
      if (window.Osano) {
        window.Osano.cm.showDrawer();
      }
    };

    const showOTCookieDrawer = (): void => {
      if (window.OneTrust) {
        window.OneTrust.ToggleInfoDisplay();
      }
    };
    return (
      <UitkSpacing className="CookieConsentToggle" padding={{ blockstart: "two" }}>
        <div id={id}>
          <Experiment name={"Osano_OneTrust_Throttle"}>
            <ExperimentControl>
              <TrackedLink data-cy="show-cookie-drawer-link" moduleName="" onClick={showCookieDrawer}>
                {formatText("cookieConsent.cookiePreferences.label")}
              </TrackedLink>
            </ExperimentControl>
            <ExperimentVariant bucket={1}>
              <TrackedLink data-cy="show-cookie-drawer-link" moduleName="" onClick={showOTCookieDrawer}>
                {formatText("cookieConsent.cookiePreferences.label")}
              </TrackedLink>
            </ExperimentVariant>
          </Experiment>
        </div>
      </UitkSpacing>
    );
  })
);

export default CookieConsentToggle;
